// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_contentContainer__YlbMn {
  height: 54vh;
  overflow-y: scroll; }

.styles_feedContainer__opTrF {
  width: 100%;
  height: 100%; }

.styles_searchContainer__G\\+\\+JT {
  margin: 1rem 2rem; }

.styles_searchInput__AXE0N {
  width: 100%; }

.styles_trackedTimeItem__3o5VY {
  margin-bottom: 0.5rem; }

.styles_header__D3DKw {
  display: flex;
  justify-content: space-between;
  align-items: center; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/submodules/trackedTime/components/TrackTimeForm/styles.module.scss"],"names":[],"mappings":"AAEA;EACI,YAAY;EACZ,kBAAkB,EAAA;;AAGtB;EACI,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,iBAAiB,EAAA;;AAIrB;EACI,WAAW,EAAA;;AAGf;EACI,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,8BAA8B;EAC9B,mBAAmB,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.contentContainer {\n    height: 54vh;\n    overflow-y: scroll;\n}\n\n.feedContainer {\n    width: 100%;\n    height: 100%;\n}\n\n.searchContainer {\n    margin: 1rem 2rem;\n    // width: 100%;\n}\n\n.searchInput {\n    width: 100%;\n}\n\n.trackedTimeItem {\n    margin-bottom: 0.5rem;\n}\n\n.header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"contentContainer": `styles_contentContainer__YlbMn`,
	"feedContainer": `styles_feedContainer__opTrF`,
	"searchContainer": `styles_searchContainer__G++JT`,
	"searchInput": `styles_searchInput__AXE0N`,
	"trackedTimeItem": `styles_trackedTimeItem__3o5VY`,
	"header": `styles_header__D3DKw`
};
export default ___CSS_LOADER_EXPORT___;
